import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import EditCloverPointConfigContext from 'contexts/EditCloverPointConfigContext';
import { useTranslation } from 'react-i18next';
import CloverPointConfigForm from 'forms/CloverPointConfigForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedCloverPointConfig } = React.useContext(EditCloverPointConfigContext);
  if (!selectedCloverPointConfig) {
    history.push('/private/admin/payments/clover-point');
    return <></>;
  }

  return (
    <div>
      <CloverPointConfigForm config={selectedCloverPointConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
